import { render, staticRenderFns } from "./ProgramPanel.vue?vue&type=template&id=43cbf569&scoped=true"
import script from "./ProgramPanel.vue?vue&type=script&lang=js"
export * from "./ProgramPanel.vue?vue&type=script&lang=js"
import style0 from "./ProgramPanel.vue?vue&type=style&index=0&id=43cbf569&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cbf569",
  null
  
)

export default component.exports